import { createPortal } from "react-dom";

import ModalOverlay from "./ModalOverlay";
import Backdrop from "./Backdrop";

const portalElement: HTMLElement = document.getElementById("overlays")!;

type Props = {
  onClose: React.MouseEventHandler<HTMLDivElement>;
  children: React.ReactNode;
  targetWebsite?: string;
};

const Modal = ({ onClose, children, targetWebsite }: Props) => {
  return (
    <>
      {createPortal(<Backdrop onClose={onClose} />, portalElement)}
      {createPortal(
        <ModalOverlay onClose={onClose} targetWebsite={targetWebsite}>
          {children}
        </ModalOverlay>,
        portalElement
      )}
    </>
  );
};

export default Modal;
